import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import ImageWorkspaceSettings from "../../../../src/content/blog-posts/configuring-your-workspace/image1.png";
import ImageEditRooms from "../../../../src/content/blog-posts/configuring-your-workspace/image2-edit-rooms.png";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  ImageWorkspaceSettings,
  ImageEditRooms,
  React
};